import { ToggleInput, ToggleLabel, ToggleSwitcher } from './styles';
import { useEffect, useMemo, useState } from 'react';

import RoundIconButton from '@components/RoundIconButton';
import { useTheme } from 'styled-components';

interface ToggleProps {
  onChange?: (value: boolean) => void;
  value: boolean;
  disabled?: boolean;
  id?: string;
  round?: boolean;
  notChangeable?: boolean;
  onClick?: () => void;
  size?: string;
  iconSize?: number;
  testId?: string;
  preventDefault?: boolean;
}

const Toggle = ({
  round,
  onChange,
  notChangeable,
  value,
  id,
  disabled = false,
  onClick,
  size,
  iconSize,
  preventDefault = false,
}: ToggleProps) => {
  const theme = useTheme();
  const [checked, setChecked] = useState<boolean>(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const toggle = () => {
    if (disabled) return;
    if (onChange) {
      onChange(!checked);
      setChecked(!checked);
    }
  };

  const iconBgColor = useMemo(() => {
    if (checked) {
      return disabled ? theme.color.grey2 : theme.color.primary;
    }
    return theme.color.white;
  }, [
    checked,
    disabled,
    theme.color.grey2,
    theme.color.primary,
    theme.color.white,
  ]);

  return (
    <>
      <ToggleInput
        disabled={disabled}
        id={id}
        type="checkbox"
        onChange={toggle}
      />
      <ToggleLabel $round={round} htmlFor={id} $checked={checked} $size={size}>
        {round ? (
          <RoundIconButton
            iconName="check"
            width={size ?? '3rem'}
            height={size ?? '3rem'}
            iconSize={iconSize}
            iconBgColor={iconBgColor}
            iconColor={theme.color.white}
            onClick={(e: { preventDefault: () => void }) => {
              if (preventDefault) e.preventDefault();
              if (!notChangeable) {
                if (onClick) onClick();
                else toggle();
              }
            }}
          />
        ) : (
          <ToggleSwitcher $checked={checked} />
        )}
      </ToggleLabel>
    </>
  );
};

export default Toggle;
